module.exports = __webpack_public_path__ + "img/LATIN10_05.a6f52685.jpg";